import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_onMultiVarSelected = new ThunderDispatcher('__onMultiVarSelected', true);
export const dispatch_onDiseaseProfileSelected = new ThunderDispatcher('__onDiseaseProfileSelected', true);
export const dispatch_onDiseaseViewSelected = new ThunderDispatcher('__onDiseaseViewSelected', true);
//# sourceMappingURL=dispatchers.js.map